export * from './durchgang-detail.component';
export * from './durchgang-detail.component.module';